// routes
import Router from "./routers";

import { AuthProvider } from "./auth/auth-provider";
import { ChatProvider } from "./auth/chat-provider";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "./services/entraId";

export default function App() {
  return (
    <MsalProvider instance={msalInstance}>
      <ChatProvider>
        <AuthProvider>
          <Router />
        </AuthProvider>
      </ChatProvider>
    </MsalProvider>
  );
}
